import axios from '../../../axios';
import IEmailDTO from '../../../types/IEmailDTO';
import IConsultant from '../types/IConsultant';
import IConsultantImportStats from '../types/IConsultantImportStats';
import IConsultantJobSearch from '../types/IConsultantJobSearch';
import IConsultantSearchFilterDTO from '../types/IConsultantSearchFilterDTO';

export const fetchConsultants = (filter: IConsultantSearchFilterDTO) =>
  axios.post('/consultants/api/_search/consultants', filter);

export const fetchMatchingJobs = (jobSearchQuery: IConsultantJobSearch[]) =>
  axios.post('/jobsearch/api/global-jobs/get-active-jobs-counts-for-consultants', jobSearchQuery);

export const saveNewConsultant = (newConsultant: { consultants: IConsultant[] }) =>
  axios.post('/consultants/api/consultants/multiple', newConsultant);

export const pingOnUpload = () =>
  axios.post('/consultants/api/consultants/bulk/save-import-status', {
    status: 'UPLOADED',
  });

export const uploadBulkConsultants = (bulkData: {
  consultants: IConsultant[];
  consultantImportStats: Partial<IConsultantImportStats>;
}) => axios.post('/consultants/api/consultants/bulk/import', bulkData);

export const updateConsultantAvailability = (update: IConsultant) =>
  axios.put('/consultants/api/consultants', update);

export const updateBulkConsultants = (update: IConsultant[]) =>
  axios.post('/consultants/api/consultants/bulk-update', update);

export const askForResume = (payload: IEmailDTO) =>
  axios.post('/consultants/api/consultants/ask-for-resume', payload);
